import { render, staticRenderFns } from "./Measure.vue?vue&type=template&id=4c38bdd7&"
import script from "./Measure.vue?vue&type=script&lang=js&"
export * from "./Measure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports